var r = /\s/;
function d(t) {
  for (var e = t.length; e-- && r.test(t.charAt(e)); )
    ;
  return e;
}
var n = d;
export {
  n as default
};
//# sourceMappingURL=_trimmedEndIndex.js.map
